async function CalcDuctLoss(length, diameter, velocity, typeofpipe) {
    //Referenced as "Pressure Loss in H2O"
    if (
        length.length > 0 &&
        diameter.length > 0 &&
        velocity.length > 0 &&
        typeofpipe.length != null &&
        typeofpipe != ""
    ) {

        let response;

        let params = JSON.stringify(
            {
                "length": length,
                "diameter": diameter,
                "velocity": velocity,
                "typeOfPipe": typeofpipe
            }
        );

        response = await fetch("https://api.cssi.co/Calc/CalculateDuctLossFactor", {
            method: "POST",
            body: params
        })
            .then(response => {
                return response.json();
            })
            .catch(e => {
                e.name === "AbortError" ? console.log("Fetch Aborted") : console.log(e.message);
            })
        return Promise.resolve(response);
    }
}

export default CalcDuctLoss;